import script from "./VeBalUnlockForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./VeBalUnlockForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__